import { Box, Typography, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

type FeaturesChangeSectionProps = {
  features: string[];
  type: 'gained' | 'lost';
};

const FeaturesChangeSection = ({ features, type }: FeaturesChangeSectionProps) => {
  if (features.length === 0) {
    return null;
  }

  const isGained = type === 'gained';
  const color = isGained ? 'success' : 'warning';
  const Icon = isGained ? CheckCircleIcon : CancelIcon;
  const titleId = isGained
    ? 'subscriptionChangeDialog.gainedFeatures'
    : 'subscriptionChangeDialog.lostFeatures';
  const defaultTitle = isGained ? '✨ Získáte další nové funkce:' : '⚠️ Ztratíte tyto funkce:';

  return (
    <Box>
      <Typography variant="subtitle2" color={`${color}.main`} gutterBottom>
        <FormattedMessage id={titleId} defaultMessage={defaultTitle} />
      </Typography>
      <Stack spacing={0.5}>
        {features.map((feature, index) => (
          <Stack key={index} direction="row" spacing={1} alignItems="center">
            <Icon fontSize="small" color={color} />
            <Typography variant="body2">{feature}</Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default FeaturesChangeSection;
